import { IExtendedFetchResult, RequestMethods } from 'networking/fetchConfig';
import { productCatalogFetch } from './productCatalogFetch';

export const updateTnc = (productUuid: string, tnc: { [key: string]: string }): Promise<IExtendedFetchResult<null>> =>
  productCatalogFetch(RequestMethods.PUT, `/v2/products/${productUuid}/tnc`, tnc);
